export function includesIgnoreCase(value, searchTerm) {
  return (value || '').toLowerCase().includes(searchTerm);
}
